import React from 'react';
import { MessageCircle } from 'lucide-react';
import { WA_LINK } from '../lib/constants';
export function StickyWhatsApp() {
  return <a href={WA_LINK} target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 flex h-16 w-16 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-110 hover:shadow-xl" aria-label="Contactar por WhatsApp" data-id="element-155">
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#25D366] opacity-40" data-id="element-156"></span>
      <MessageCircle size={32} className="relative z-10" data-id="element-157" />
    </a>;
}